import * as React from "react";
import uuid from "react-uuid";

import { makeStyles, MenuItem, Select } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    color: "#acacac",
    border: "2px solid #ededed",
    borderRadius: "6px",
    transition: "box-shadow .15s ease",
    margin: "auto",
    alignSelf: "center",
    padding: "15px 0",
    height: props.height,

    "& .MuiSelect-select:focus": {
      borderColor: "#ededed",

      backgroundColor: "transparent",
    },

    "& .MuiSelect-icon": {
      fontSize: "30px",
      color: "#acacac",
    },
  }),
}));

const SolidSelectBox = ({
  items,
  height = "auto",
  extraHandler,
  defaultValue = 0,
}) => {
  const classes = useStyles({ height });
  const [selectValue, setSelectValue] = React.useState(defaultValue);

  React.useEffect(() => {
    setSelectValue(defaultValue)
  }, [defaultValue])
  

  const handleChange = (e) => {
    setSelectValue(e.target.value);
    if (typeof extraHandler === "function") {
      extraHandler(e.target.value);
    }
  };
  return (
    <Select
      fullWidth
      variant="outlined"
      onChange={handleChange}
      value={selectValue}
      className={classes.root}
    >
      {items &&
        items.map((item) => (
          <MenuItem key={uuid()} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
    </Select>
  );
};

export default SolidSelectBox;
